export const gaMeasurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;
export const isGaEnabled = Boolean(gaMeasurementId);
